import './assets/css';

import './i18n';

import angular from 'angular';
import { UI_ROUTER_REACT_HYBRID } from '@uirouter/react-hybrid';

import analyticsModule from './shbdeployer/analytics';

import './agent';
import './azure/_module';
import './docker/__module';
import './edge/__module';
import './core/__module';

import { onStartupAngular } from './app';
import { configApp } from './config';

angular
  .module('shbdeployer', [
    'ui.bootstrap',
    'ui.router',
    UI_ROUTER_REACT_HYBRID,
    'ui.select',
    'isteven-multi-select',
    'ngSanitize',
    'ngFileUpload',
    'ngMessages',
    'ngResource',
    'angularUtils.directives.dirPagination',
    'LocalStorageModule',
    'angular-jwt',
    'angular-json-tree',
    'angular-loading-bar',
    'angular-clipboard',
    'ngFileSaver',
    'luegg.directives',
    'shbdeployer.app',
    'shbdeployer.agent',
    'shbdeployer.azure',
    'shbdeployer.docker',
    'shbdeployer.kubernetes',
    'shbdeployer.edge',
    'shbdeployer.integrations',
    'rzModule',
    'moment-picker',
    analyticsModule,
  ])
  .run(onStartupAngular)
  .config(configApp);

if (require) {
  const req = require.context('./', true, /^(.*\.(js$))[^.]*$/im);
  req
    .keys()
    .filter((path) => !path.includes('.test'))
    .forEach(function (key) {
      req(key);
    });
}

// Последним — слой оформления ShbDeployer: он должен перекрывать стили
// компонентов, унаследованные от исходного продукта (см. assets/css/design-system.js).
require('./assets/css/design-system');
